import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { ModalControlResponse, Modal } from '@frontend/design-system';
import CreateFormLoader from '../loader/loader.component';
import { useCreateFormStepsStore } from '../provider';
import UsageTermsStepFooter, { UsageTermsStepFooterProps } from './footer/footer.component';
import UsageTerms from './usage-terms/usage-terms.component';
import UsageTermsStepCheckbox from './usage-terms-checkbox/usage-terms-checkbox.component';

export interface UsageTermsStepProps extends UsageTermsStepFooterProps {
  modalControls: ModalControlResponse;
}

const UsageTermsStep: FC<UsageTermsStepProps> = ({ modalControls, ...footerProps }) => {
  const { t } = useTranslation('forms');
  const { isCreatingForm } = useCreateFormStepsStore(['isCreatingForm']);

  return (
    <Modal
      {...modalControls.modalProps}
      maxWidth={800}
      disableCloseOnEscape={isCreatingForm}
      disableCloseOnOverlayClick={isCreatingForm}
    >
      <Modal.Header onClose={modalControls.closeModal}>{t('Template Usage Terms')}</Modal.Header>
      <Modal.Body>
        <UsageTerms />
        <UsageTermsStepCheckbox />
      </Modal.Body>
      <UsageTermsStepFooter {...footerProps} />
      <CreateFormLoader />
    </Modal>
  );
};

export default UsageTermsStep;
